import template from './payment.html';
export var PaymentComponent = {
    template: template,
    controller: /** @class */ (function () {
        function PaymentComponent() {
        }
        return PaymentComponent;
    }())
};
//# sourceMappingURL=payment.component.js.map